/**
 * @desc 待POD上传信息提交
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.Response;
export function request(body: defs.tms.TransportDpodRequestDto, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/dpodTransportMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
